module.exports = "https://cdn.littlereply.com/tt/resource/icon_like_white.e37c55a9d63441520d0722860a0309b2.png";